export default {
    noWrap: {
        whiteSpace: 'nowrap',
    },
    preWrap: {
        whiteSpace: 'pre-wrap',
    },
    pre: {
        whiteSpace: 'pre',
    },
};
